import React, { useEffect, useState, useRef } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom"; // Pour la navigation

import Box from "@mui/joy/Box";
import { Badge } from "@mui/material";
import useCollectionData from "./Component/useCollectionData";
import { useGetUserConnecteData } from "../Utilisateur/Component/RecupererDonneeUser";
import { useUser } from "../../Services/ContexteUser";

export default function Collection() {
  const navigate = useNavigate();
  const currentUser = localStorage.getItem("userUid");
  const idOrganisation = localStorage.getItem("idOrganisation");

  const { userData } = useGetUserConnecteData(currentUser);

  const { updateMonnaie } = useUser(); // Récupère updateMonnaie du contexte

  const [countdown, setCountdown] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  const [collectionData, setCollectionData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [items, setItems] = useState([]);

  const [packPrice, setPackPrice] = useState(25);

  useEffect(() => {
    const storedCollection = localStorage.getItem("selectedCollection");
    if (storedCollection) {
      const collectionData = JSON.parse(storedCollection);
      setCollectionData(collectionData);

      // 🔹 Mettre à jour packPrice si disponible
      if (collectionData.PackPrice) {
        setPackPrice(collectionData.PackPrice);
      }
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    const storedCollection = localStorage.getItem("selectedCollection");
    if (storedCollection) {
      const collectionData = JSON.parse(storedCollection);

      // Vérifier si collectionData est valide avant de le déstructurer
      if (!collectionData) {
        console.error("Aucune collection trouvée dans le localStorage.");
        return;
      }

      const ultraRare = collectionData.ultraRare || {};
      const rare = collectionData.rare || {};
      const commune = collectionData.commune || {};
      const urls = collectionData.urls || {};

      // Convertir les objets en tableaux et ajouter les raretés
      const ultraRareCards = Object.values(ultraRare).map((uid, index) => ({
        id: uid,
        title: String(index).padStart(3, "0"),
        imageUrl: urls[uid] || "",
        rarity: "ultraRare",
      }));

      const rareCards = Object.values(rare).map((uid, index) => ({
        id: uid,
        title: String(index + ultraRareCards.length).padStart(3, "0"),
        imageUrl: urls[uid] || "",
        rarity: "rare",
      }));

      const communeCards = Object.values(commune).map((uid, index) => ({
        id: uid,
        title: String(
          index + ultraRareCards.length + rareCards.length
        ).padStart(3, "0"),
        imageUrl: urls[uid] || "",
        rarity: "commune",
      }));

      // Trier par rareté (ultraRare > rare > commune)
      const sortedItems = [...ultraRareCards, ...rareCards, ...communeCards];

      // Mettre à jour le state
      setItems(sortedItems);
    } else {
      console.warn("Aucune donnée trouvée dans le localStorage.");
    }
  }, []);

  const updatedItems = [...items];

  ////// Affichage des cartes : replacement lors du grossissement
  // Si l'index sélectionné est impair, réorganisez les cartes
  if (selectedImageIndex % 2 !== 0) {
    const selectedIndex = updatedItems.findIndex(
      (item) => item.id === selectedImageIndex
    );
    if (selectedIndex > 0) {
      const previousItem = updatedItems[selectedIndex - 1];
      updatedItems.splice(selectedIndex - 1, 1); // Supprime l'élément précédent
      updatedItems.splice(selectedIndex, 0, previousItem); // Ajoute après l'élément sélectionné
    }
  }

  ////// Affichage des cartes : grossissement
  const handleImageClick = (index) => {
    if (selectedImageIndex === index) {
      setSelectedImageIndex(null); // Désélectionner si l'image est déjà agrandie
    } else {
      setSelectedImageIndex(index); // Sélectionner l'image pour l'agrandir
    }
  };

  const isMonnaieSufficient = userData?.nbMonnaie >= packPrice;

  const handleOpenPack = async () => {
    if (isMonnaieSufficient) {
      const newKiff = userData.nbMonnaie - packPrice; // Utilisation de PackPrice dynamique

      if (newKiff !== null) {
        try {
          const updateResponse = await fetch(
            "https://backend-betkiff.vercel.app/users/updateMonnaie",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                userId: userData.idUser,
                newMoney: newKiff,
                idOrganisation,
              }),
            }
          );

          if (updateResponse.ok) {
            updateMonnaie(newKiff); // Mise à jour du contexte monnaie
            localStorage.setItem("opening", JSON.stringify(true));
            navigate("/packopening");
          }
        } catch (error) {
          console.error("Erreur lors de la mise à jour des kiffs :", error);
        }
      }
    }
  };

  const collection = useCollectionData(userData, [
    collectionData?.idCollection,
  ]);

  console.log("userData", userData);

  ////// Vérifie si le temps du dernier pack gratuit est de plus ou moins 12h
  const isLessThan12h = (lastOpening) => {
    if (!lastOpening) return false;

    const lastOpeningDate = new Date(lastOpening);
    const now = new Date();

    const differenceInMilliseconds = now - lastOpeningDate;
    const differenceInHours = differenceInMilliseconds / (1000 * 60 * 60);

    return differenceInHours < 12;
  };

  ////// Compte à rebours pour le pack gratuit
  const calculateCountdown = (lastOpening) => {
    if (!lastOpening) return null;

    const lastOpeningDate = new Date(lastOpening);
    const nextFreePackTime = new Date(
      lastOpeningDate.getTime() + 12 * 60 * 60 * 1000
    );

    const now = new Date();

    const timeLeft = nextFreePackTime - now;

    if (timeLeft <= 0) return null; // Si le temps est écoulé, pas de compte à rebours

    const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 12);
    const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
    const seconds = Math.floor((timeLeft / 1000) % 60);

    return { hours, minutes, seconds };
  };

  let lessThan12h = true;

  if (userData?.last_opening) {
    lessThan12h = isLessThan12h(userData.last_opening);
  }

  ////// Modif de last_opening dans la bdd + déclanchement du pack opening gratiut avec la redirection
  const handleFreeOpenPack = async () => {
    try {
      // Obtenir la date et l'heure actuelles
      const now = new Date().toISOString();

      // Appeler l'API backend pour mettre à jour last_opening
      const response = await fetch(
        "https://backend-betkiff.vercel.app/users/updateUserLastOpening",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: userData.idUser,
            newLastOpening: now,
            idOrganisation,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Erreur API mise à jour last_opening :", errorData);
        throw new Error(errorData.error || "Erreur lors de la mise à jour.");
      }

      // Mise à jour réussie, stocker et naviguer
      localStorage.setItem("opening", JSON.stringify(true));
      navigate("/packopening");
    } catch (error) {
      console.error(
        "Erreur lors de la mise à jour de la base de données :",
        error
      );
    }
  };

  ////// gestioin du délai pour le pack gratuit avec calculateCountdown
  useEffect(() => {
    if (lessThan12h) {
      const interval = setInterval(() => {
        const newCountdown = calculateCountdown(userData?.last_opening);
        setCountdown(newCountdown);

        if (!newCountdown) {
          clearInterval(interval); // Arrête le compte à rebours quand il arrive à zéro
        }
      }, 1000);

      return () => clearInterval(interval); // Nettoyage du timer à la fin
    } else {
      setCountdown(null); // Réinitialiser si le délai est passé
    }
  }, [lessThan12h, userData?.last_opening]);

  const refs = useRef({}); // Stocke les références des éléments

  // Effet pour centrer l'élément sélectionné
  useEffect(() => {
    if (selectedImageIndex && refs.current[selectedImageIndex]) {
      refs.current[selectedImageIndex].scrollIntoView({
        behavior: "smooth", // Animation douce
        block: "center", // Centrer verticalement
        inline: "center", // Centrer horizontalement (si nécessaire)
      });
    }
  }, [selectedImageIndex]);

  useEffect(() => {
    setIsLoading(!userData); // isLoading est vrai tant que userData est null
  }, [userData]);

  return (
    <div style={{ padding: "20px", marginTop: "15%", paddingBottom: "20%" }}>
      {isLoading ? (
        <Box
          sx={{
            padding: 3,
            display: "flex",
            flexDirection: "column",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            borderRadius: "20px",
            zIndex: 100,
            width: "80%",
            maxWidth: "1200px",
          }}>
          <Grid
            container
            sx={{ textAlign: "center", width: "100%", alignItems: "center" }}>
            <Typography
              variant="h7"
              sx={{
                color: "black", // Couleur conditionnelle
                fontWeight: "bold",
              }}>
              Chargement...
            </Typography>
          </Grid>
        </Box>
      ) : (
        <>
          <Paper
            elevation={3}
            sx={{
              borderRadius: "20px",
              marginBottom: "10px",
              backgroundColor: "transparent",
            }}>
            <Grid
              container
              sx={{ textAlign: "center", width: "100%", alignItems: "center" }}>
              <Grid item xs={6}>
                <Typography
                  variant="h7"
                  sx={{
                    color: isMonnaieSufficient ? "black" : "red", // Changement de couleur si insuffisant
                    fontWeight: "bold",
                  }}>
                  🤙{packPrice} {/* Affichage dynamique du PackPrice */}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleOpenPack}
                  sx={{
                    width: "100%",
                    borderRadius: "20px",
                    backgroundColor: isMonnaieSufficient
                      ? "#ee95f6"
                      : "transparent", // Fond conditionnel
                    border: isMonnaieSufficient ? "none" : "1px solid red", // Contour rouge si monnaie insuffisante
                    "&:hover": {
                      backgroundColor: isMonnaieSufficient
                        ? "#ee95f6"
                        : "transparent",
                    },
                  }}
                  disabled={!isMonnaieSufficient}>
                  Ouvrir un pack
                </Button>
              </Grid>
            </Grid>
          </Paper>
          <Paper
            elevation={3}
            sx={{
              borderRadius: "20px",
              marginBottom: "20px",
              backgroundColor: "transparent",
            }}>
            <Grid
              container
              sx={{ textAlign: "center", width: "100%", alignItems: "center" }}>
              <Grid item xs={6}>
                <Typography
                  variant="h7"
                  sx={{
                    color:
                      lessThan12h && userData?.last_opening ? "red" : "black", // Couleur conditionnelle
                    fontWeight: "bold",
                  }}>
                  Pack gratuit
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleFreeOpenPack}
                  sx={{
                    width: "100%",
                    borderRadius: "20px",
                    backgroundColor:
                      isLoading || (lessThan12h && userData?.last_opening)
                        ? "transparent"
                        : "#ee95f6",
                    border:
                      isLoading || (lessThan12h && userData?.last_opening)
                        ? "1px solid red"
                        : "none",
                    "&:hover": {
                      backgroundColor:
                        isLoading || lessThan12h ? "transparent" : "#ee95f6",
                    },
                  }}
                  disabled={
                    isLoading || (lessThan12h && userData?.last_opening)
                  }>
                  {isLoading
                    ? "Chargement..."
                    : lessThan12h && countdown && userData?.last_opening
                      ? `${countdown.hours}h ${countdown.minutes}m ${countdown.seconds}s`
                      : "Ouvrir un pack"}
                </Button>
              </Grid>
            </Grid>
          </Paper>
          <Grid container spacing={2}>
            {updatedItems.map((item, index) => {
              const userCard = collection.find(
                (card) => card.title === item.id
              );
              const hasCard = !!userCard;
              const doublons = userCard?.doublons || 0;

              return (
                <Grid
                  item
                  xs={selectedImageIndex === item.id ? 12 : 6}
                  sm={selectedImageIndex === item.id ? 12 : 6}
                  md={selectedImageIndex === item.id ? 12 : 6}
                  key={item.id}
                  sx={{
                    minHeight:
                      selectedImageIndex === item.id ? "440px" : "220px",
                  }}
                  ref={(el) => (refs.current[item.id] = el)}>
                  <Paper
                    elevation={3}
                    sx={{
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      position: "relative", // Nécessaire pour positionner la pastille
                      backgroundColor: "transparent",
                    }}>
                    {hasCard && (
                      <Box
                        sx={{
                          position: "relative",
                          width: "100%",
                          height: "100%",
                        }}>
                        <img
                          src={item.imageUrl}
                          alt={item.title}
                          style={{
                            width: "100%",
                            height: "100%",
                            cursor: "pointer",
                            objectFit: "cover",
                          }}
                          onClick={() => handleImageClick(item.id)}
                        />
                        {/* Affichage de la pastille si le nombre de doublons est supérieur à 1 */}
                        {doublons > 1 && (
                          <Badge
                            badgeContent={doublons}
                            color="secondary"
                            sx={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              "& .MuiBadge-badge": {
                                fontSize: 15,
                                height: 25,
                                minWidth: 25,
                              },
                            }}
                          />
                        )}
                      </Box>
                    )}
                    {!hasCard && (
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: "bold",
                          color: "#e1bfe4",
                          textShadow: "1px 1px 4px rgba(0, 0, 0, 0.7)",
                        }}>
                        {item.title}
                      </Typography>
                    )}
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
        </>
      )}
    </div>
  );
}
